//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sandbox from './components/Sandbox.vue';
import SandboxTemplate from './components/SandboxTemplate.vue';
import RefreshList from './components/RefreshList.vue';
export default {
  components: {
    Sandbox,
    SandboxTemplate,
    RefreshList,
  },
  data() {
    return {
      // tab状态
      activeStatus: 'Sandbox',
    };
  },
};
